import { render, staticRenderFns } from "./GameScoreInput.vue?vue&type=template&id=08cb60f4&scoped=true&"
import script from "./GameScoreInput.vue?vue&type=script&lang=js&"
export * from "./GameScoreInput.vue?vue&type=script&lang=js&"
import style0 from "./GameScoreInput.vue?vue&type=style&index=0&id=08cb60f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb60f4",
  null
  
)

export default component.exports